export default Object.freeze({
  ACCOUNT_TYPES: {
    FREE: 'FREE',
    PRO: 'PRO',
    LIFE: 'LIFE'
  }
})
